<template>
  <div>
    <div
      v-if="qq.isServiceUrl == true"
      class="floatball"
      id="floatball"
      @click="kefu"
      @mousedown="down"
      @touchstart.stop="down"
      @mousemove="move"
      @touchmove.stop="move"
      @mouseup="end"
      @touchend.stop="end"
      :style="{ top: position.y + 'px', left: position.x + 'px' }"
    >
      客服
    </div>
    <div class="header">
      <van-tabs v-model="activeName">
        <van-tab
          v-for="item in nite"
          :key="item.id"
          :title="item.name"
          :name="item.id"
        >
          <div v-for="items in item.livecodeContentModels" :key="items.id">
            <div v-if="items.image == true">
              <img style="width: 100%" :src="items.content" />
            </div>
            <div v-else style="font-size: 20px; width: 100%">
              {{ items.content }}
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div
      v-if="qq.isPayUrl == true"
      @click="chong"
      style="
        position: fixed;
        bottom: 0px;
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #fff;
        font-size: 20px;
        background-color: #0089ff;
      "
    >
      点击此处充值
    </div>
  </div>
</template>

<script>
  var dx, dy;
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  import { mapActions } from "vuex";
  import { selectByLiveId } from "@/api/cardOperation";
  export default {
    name: "Apn",
    data() {
      return {
        flags: false,
        position: {
          x: 300,
          y: 600,
        },
        activeName: "",
        nite: [],
        vv: [],
        kefuurl: "",
        chongzhiurl: "",
        qq: {
          isPayUrl: false,
          isServiceUrl: false,
        },
      };
    },
    created() {
      this.getAll();
    },
    mounted() {
      this.getApnAndroid();
    },
    methods: {
      ...mapActions(["getAll"]),
      // 实现移动端拖拽
      down(event) {
        this.flags = true;
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        // console.log("鼠标点所在位置", touch.clientX, touch.clientY);
        // console.log(
        //   "div左上角位置",
        //   event.target.offsetTop,
        //   event.target.offsetLeft
        // );
        dx = touch.clientX - event.target.offsetLeft;
        dy = touch.clientY - event.target.offsetTop;
      },
      kefu() {
        window.location.href = this.kefuurl;
      },
      chong() {
        window.location.href = this.chongzhiurl;
      },
      move() {
        if (this.flags) {
          var touch;
          if (event.touches) {
            touch = event.touches[0];
          } else {
            touch = event;
          }
          // 定位滑块的位置
          this.position.x = touch.clientX - dx;
          this.position.y = touch.clientY - dy;
          // 限制滑块超出页面
          // console.log('屏幕大小', screenWidth, screenHeight )
          if (this.position.x < 0) {
            this.position.x = 0;
          } else if (this.position.x > screenWidth - touch.target.clientWidth) {
            this.position.x = screenWidth - touch.target.clientWidth;
          }
          if (this.position.y < 0) {
            this.position.y = 0;
          } else if (
            this.position.y >
            screenHeight - touch.target.clientHeight
          ) {
            this.position.y = screenHeight - touch.target.clientHeight;
          }
          //阻止页面的滑动默认事件
          document.addEventListener(
            "touchmove",
            function () {
              event.preventDefault();
            },
            false
          );
        }
      },
      //鼠标释放时候的函数
      end() {
        // console.log("end");
        this.flags = false;
      },

      getApnAndroid() {
        selectByLiveId(this.$route.params.id).then((res) => {
          if (res.status) {
            this.nite = res.data.livecodeClassifyModels;
            this.kefuurl = res.data.serviceUrl;
            this.qq.isPayUrl = res.data.isPayUrl;
            this.qq.isServiceUrl = res.data.isServiceUrl;
            this.chongzhiurl = res.data.payUrl;
            this.activeName = String(this.nite[0].id);
            this.nite.forEach((item) => {
              item.id = item.id + "";
            });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .header {
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 50px;
    background-color: white;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
  }
  .floatball {
    color: white;
    height: 40px;
    width: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    padding: 5px;
    z-index: 990;
    position: fixed;
    bottom: 50px;
    right: 20px;
    border-radius: 50%;
    background-color: rgba(29, 157, 237, 0.8);
  }
  .detail {
    padding: 5px;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
  }
</style>
